
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/dazn-member-benefits-202208",
      function () {
        return require("private-next-pages/campaign/dazn-member-benefits-202208/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/dazn-member-benefits-202208"])
      });
    }
  